function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterAlignBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13876"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3211",
    style: {
      fill: "#203662"
    },
    d: "M0 0h12v1.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3212",
    transform: "translate(2.4 3.6)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h7.2v1.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3213",
    transform: "translate(0 7.2)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h12v1.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3214",
    transform: "translate(2.4 10.8)",
    style: {
      fill: "#203662"
    },
    d: "M0 0h7.2v1.2H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterAlignBlue);
export default __webpack_public_path__ + "static/media/CenterAlignBlue.62437a60402707e2a6a67224280e5a3e.svg";
export { ForwardRef as ReactComponent };